export default "__VITE_ASSET__d23bc49f__"